// src/utils/useRecommendSingleVehicleWorker.js
import RecommendWorker from 'worker-loader!@/workers/recommendSingleVehicle.worker.js';
export function recommendSingleVehicleWithWorker(payload) {
    return new Promise((resolve, reject) => {
      // const worker = new Worker(
      //   new URL('worker-loader!@/workers/recommendSingleVehicle.worker.js', import.meta.url),
      //   { type: 'module' }
      // );
      const cleanParams = JSON.parse(JSON.stringify(payload));
      const worker = new RecommendWorker();
      worker.postMessage(cleanParams);
  
      worker.onmessage = (e) => {
        const { success, result, error } = e.data;
        if (success) resolve(result);
        else reject(new Error(error));
        worker.terminate();
      };
  
      worker.onerror = (err) => {
        reject(err);
        worker.terminate();
      };
    });
  }
  